import styled from '@emotion/styled';
import { SxProps } from '@mui/material';
import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { usePalette } from 'src/hooks/usePalette';
import { transientOptions } from '../../utils/emotion';

interface CustomProps {
  staticWidth?: string;
  loading?: boolean;
  loadingStyles?: SxProps;
}

export type ButtonProps = MuiButtonProps & CustomProps;

interface StyledButtonProps {
  $staticWidth?: string;
}

const StyledButton = styled(
  MuiButton,
  transientOptions
)<StyledButtonProps>(
  ({ $staticWidth, theme: { palette } }) => `
  width: ${$staticWidth || null};

  &:disabled {
    background-color: ${palette.grey[800]};
    color: ${palette.grey[600]};
  }
`
);

export const Button = ({
  children,
  sx,
  staticWidth,
  startIcon,
  endIcon,
  disabled,
  loading = false,
  loadingStyles,
  ...props
}: ButtonProps) => {
  const { text, background } = usePalette();

  return (
    <StyledButton
      variant='contained'
      disabled={disabled}
      $staticWidth={staticWidth}
      sx={{
        borderRadius: 12,
        textTransform: 'capitalize',
        color: text.primary,
        backgroundColor: background.paper,
        pointerEvents: loading ? 'none' : 'initial',
        ...sx
      }}
      startIcon={!loading ? startIcon : null}
      endIcon={!loading ? endIcon : null}
      {...props}
    >
      {loading ? <CircularProgress size='1.25rem' sx={{ m: 0.75, color: text.primary, ...loadingStyles }} /> : children}
    </StyledButton>
  );
};
